(function (window) {
  'use strict';

  const CONFIG = {
    ENDPOINT: 'https://storefront.retailconnect.app/v1/event',
    NOSTO_SEARCH: 'https://search.nosto.com/v1/graphql',
    NOSTO_API: 'https://api.nosto.com/v1/graphql',
    PROJECT_NAME: 'vertex-465508',
    COOKIE_NAME: 'rcc-visitor-id',
    PAGE_SIZE: 94
  };

  /**
   * Generates a UUID v4 generic compliant string.
   */
  const createUUID = () => {
    let s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19].charCodeAt(0) & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    return s.join('');
  };

  /**
   * Gets or sets the visitor ID in cookies.
   */
  const getVisitorId = () => {
    const match = document.cookie.match(new RegExp('(^|;\\s*)(' + CONFIG.COOKIE_NAME + ')=([^;]*)'));
    if (match) return decodeURIComponent(match[3]);

    const uuid = createUUID();
    const expires = new Date(Date.now() + 365 * 864e5).toUTCString();
    document.cookie = `${CONFIG.COOKIE_NAME}=${encodeURIComponent(uuid)}; expires=${expires}; path=/; SameSite=Lax`;

    return uuid;
  };

  /**
   * Sends payload to the backend.
   */
  const sendEvent = async (payload) => {
    try {
      await fetch(CONFIG.ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      });
    } catch (err) {
      console.error('[Nimstrata] API error:', err);
    }
  };

  const normalizeFilter = (filter) => ({
    field: filter.field,
    value: Array.isArray(filter.value) ? filter.value : [filter.value],
    type: filter.type || 'string'
  });

  const getUserInfo = () => ({
    userAgent: navigator.userAgent,
    userId: window.Shopify?.customer?.id?.toString() || null
  });

  const toProductDetails = (productIds) =>
    (productIds || []).map(id => ({ product: { id: String(id) } }));

  /**
   * Global function to send search event.
   */
  window.send_search_nimstrata = (searchQuery, productIds, offset, filters) => {
    let pageCategories = [];

    // Fallback to Shopify Collection ID if no query
    if (!searchQuery) {
      const { ShopifyAnalytics } = window;
      if (ShopifyAnalytics?.meta?.page?.resourceType === 'collection' &&
        ShopifyAnalytics?.meta?.page?.resourceId) {
        pageCategories.push(String(ShopifyAnalytics.meta.page.resourceId));
      }
    }

    const userEvent = {
      eventType: 'search',
      visitorId: getVisitorId(),
      offset: offset || 0,
      productDetails: toProductDetails(productIds),
      userInfo: getUserInfo(),
      searchQuery: searchQuery,
      experimentIds: ['CONTROL']
    };

    if (pageCategories.length > 0) userEvent.pageCategories = pageCategories;
    if (filters && filters.length > 0) userEvent.filter = filters.map(normalizeFilter);

    if (userEvent.searchQuery || userEvent.pageCategories) {
      sendEvent({
        projectName: CONFIG.PROJECT_NAME,
        userEvent
      });
    } else {
      console.warn('[Nimstrata] Skipping event: Missing searchQuery and pageCategories');
    }
  };

  const extractProductIdsFromNostoResponse = (data) => {
    const productIds = new Set();
    if (!data || typeof data !== 'object') return [];

    try {
      // Case 1: Search user event
      const searchHits = data?.data?.search?.products?.hits;
      if (Array.isArray(searchHits)) {
        searchHits.forEach(hit => {
          if (hit?.productId) productIds.add(String(hit.productId));
        });
      }

      // Case 2: Browser user event
      const apiProds = data?.data?.products?.products;
      if (Array.isArray(apiProds)) {
        apiProds.forEach(prod => {
          if (prod?.productId) productIds.add(String(prod.productId));
        });
      }
    } catch (e) {
      console.error('[Nimstrata] Error extracting product IDs:', e);
    }

    return Array.from(productIds);
  };

  const getUrlParams = (param) => {
    const params = new URLSearchParams(window.location.search);
    return params.get(param) || '';
  };

  const extractUrlFilters = () => {
    const filters = [];
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        filters.push({ field: key.substring(7), value });
      }
    });
    return filters;
  };

  /**
   * Intercepts global fetch to capture search results.
   */
  const setupFetchInterceptor = () => {
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const [resource, config] = args;
      const url = (resource instanceof Request) ? resource.url : resource;


      const response = await originalFetch.apply(this, args);
      const clone = response.clone();

      const isSearchEndpoint = typeof url === 'string' && url.indexOf(CONFIG.NOSTO_SEARCH) !== -1;

      if (isSearchEndpoint) {
        try {
          const data = await clone.json();

          let searchQuery = data?.data?.search?.query || '';
          if (!searchQuery) {
            searchQuery = getUrlParams('q');
          }

          const productIds = extractProductIdsFromNostoResponse(data);
          const filters = extractUrlFilters();

          if (productIds.length > 0) {
            const page = parseInt(getUrlParams('page')) || 1;
            const offset = (page - 1) * CONFIG.PAGE_SIZE;
            window.send_search_nimstrata(searchQuery, productIds, offset, filters);
          }
        } catch (e) {
          console.error('[Nimstrata] Error parsing Fetch response:', e);
        }
      }

      return response;
    };
  };

  setupFetchInterceptor();

})(window);
